export function pad(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
}

export function formatDate(date) {
    let d = new Date(date);
    return pad(d.getDate()) + "-" + pad((d.getMonth() + 1)) + "-" + d.getFullYear() + " " +
        (d.getHours() !== 0 ? d.getHours() + ":" : "") + (d.getHours() !== 0 ? d.getMinutes() : "");
}